(function() {
  var ViewMachine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ViewMachine = App.loadClass("grower::handlers/machinery/DialogViewMachinery_Handler");

  exports.DialogAddMachinery_Handler = (function(superClass) {
    extend(DialogAddMachinery_Handler, superClass);

    function DialogAddMachinery_Handler() {
      return DialogAddMachinery_Handler.__super__.constructor.apply(this, arguments);
    }

    DialogAddMachinery_Handler.prototype.init = function() {
      this.layoutUrl = "backend/grower/machinery/load-layout-add-machinery";
      return this.createDialog();
    };

    DialogAddMachinery_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {

      }
    };

    DialogAddMachinery_Handler.prototype.submitAction = function() {
      var add;
      add = this.parent.createSubHandler(ViewMachine);
      if (add) {
        add.saveUrl = 'backend/grower/machinery/save';
        add.wantAdd = true;
        add.machinery_type = this.dialog.find('#machinery_type_id').val();
        return add.init();
      }
    };

    return DialogAddMachinery_Handler;

  })(DialogHandler);

}).call(this);
